/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Cancel_TrialInputs */

const en_pricing_cancel_trial = /** @type {(inputs: Pricing_Cancel_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel before your trial ends to avoid being charged.`)
};

const es_pricing_cancel_trial = /** @type {(inputs: Pricing_Cancel_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela antes de que termine la prueba para evitar el cobro.`)
};

/**
* | output |
* | --- |
* | "Cancel before your trial ends to avoid being charged." |
*
* @param {Pricing_Cancel_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_cancel_trial = /** @type {((inputs?: Pricing_Cancel_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Cancel_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_cancel_trial(inputs)
	return en_pricing_cancel_trial(inputs)
});